module.exports = __webpack_public_path__ + "141d4a85/img/document.e2130c6b.svg";